module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.entity.sections) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "welcome-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.welcome.title),
      expression: "entity.sections.welcome.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "welcome-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.welcome.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.welcome, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-welcome"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-welcome"
    },
    model: {
      value: (_vm.entity.sections.welcome.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.welcome, "description", $$v)
      },
      expression: "entity.sections.welcome.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Images Slider")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-slider"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    attrs: {
      "id": "public-slider",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.images_slider.show) ? _vm._i(_vm.entity.sections.images_slider.show, null) > -1 : (_vm.entity.sections.images_slider.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.images_slider.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.images_slider, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    attrs: {
      "id": "include-slider",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.images_slider.show) ? _vm._i(_vm.entity.sections.images_slider.show, null) > -1 : (_vm.entity.sections.images_slider.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.images_slider.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.images_slider, "show", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    staticClass: "col-md-12 mt-2"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select Images\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "about-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.about.title),
      expression: "entity.sections.about.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "about-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.about.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.about, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-about"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-about"
    },
    model: {
      value: (_vm.entity.sections.about.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.about, "description", $$v)
      },
      expression: "entity.sections.about.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Announcements")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-announcements"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.announcements.show),
      expression: "entity.sections.announcements.show"
    }],
    attrs: {
      "id": "public-announcements",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.announcements.show) ? _vm._i(_vm.entity.sections.announcements.show, null) > -1 : (_vm.entity.sections.announcements.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.announcements.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.announcements, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.announcements, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.announcements, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcements-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.announcements.title),
      expression: "entity.sections.announcements.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "announcements-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.announcements.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.announcements, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("News Notes")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-news-notes"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.news_notes.show),
      expression: "entity.sections.news_notes.show"
    }],
    attrs: {
      "id": "public-news-notes",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.news_notes.show) ? _vm._i(_vm.entity.sections.news_notes.show, null) > -1 : (_vm.entity.sections.news_notes.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.news_notes.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.news_notes, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.news_notes, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.news_notes, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news_notes-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.news_notes.title),
      expression: "entity.sections.news_notes.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "news_notes-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.news_notes.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.news_notes, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Contact")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-contact"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.contact.show),
      expression: "entity.sections.contact.show"
    }],
    attrs: {
      "id": "public-contact",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.contact.show) ? _vm._i(_vm.entity.sections.contact.show, null) > -1 : (_vm.entity.sections.contact.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.contact.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.contact, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.contact, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.contact, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "contact-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.contact.title),
      expression: "entity.sections.contact.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contact-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.contact.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.contact, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-contact"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-contact"
    },
    model: {
      value: (_vm.entity.sections.contact.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.contact, "description", $$v)
      },
      expression: "entity.sections.contact.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Location")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-location"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.show),
      expression: "entity.sections.location.show"
    }],
    attrs: {
      "id": "public-location",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.location.show) ? _vm._i(_vm.entity.sections.location.show, null) > -1 : (_vm.entity.sections.location.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.location.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.location, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.location, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.location, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Name of Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.title),
      expression: "entity.sections.location.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleLink",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.location.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.location, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lat),
      expression: "entity.location.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.location.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lng),
      expression: "entity.location.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.location.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.location) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.sourceMapData.center,
      "zoom": _vm.sourceMapData.zoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [(_vm.entity.location.lat && _vm.entity.location.lng) ? _c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "include-slider"
    }
  }, [_vm._v("Show Contact Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.show_contact_info),
      expression: "entity.sections.location.show_contact_info"
    }],
    attrs: {
      "id": "show-contact-info",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.location.show_contact_info) ? _vm._i(_vm.entity.sections.location.show_contact_info, null) > -1 : (_vm.entity.sections.location.show_contact_info)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.location.show_contact_info,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.location, "show_contact_info", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.location, "show_contact_info", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.location, "show_contact_info", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])])]) : _c('div', [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Welcome")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-welcome"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "public-welcome",
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("About")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-about"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "public-about",
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("There are no sections for this branch yet.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9dca39a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/sections/CenterPage.vue
// module id = 990
// module chunks = 0